<template>
  <div>
    <v-alert type="error" prominent>
      {{ $t('pages.pageNotFound') }} <br />
      {{ $t('pages.pageNotFoundDesc') }}
    </v-alert>

    <div class="d-flex justify-end">
      <v-btn to="/attendance/list" color="error" variant="outlined">{{ $t('pages.goToTopPage') }}</v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "PageNotFound",
});
</script>
